export const LINE_GAP = 0.2 // 20% of height

export const AXIS_WIDTH = 2 // 2px
